"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPerfTracker;
exports.startMetrics = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _modalLoaderUtils = require("@wsb/modal-loader-utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LOADER_NAMESPACE = _modalLoaderUtils.CONSTANTS.LOADER_NAMESPACE;

// These are sta
// See https://www.w3.org/TR/navigation-timing/#processing-model for the sequence diagram.
var startMetrics = exports.startMetrics = {
  NAVIGATION_START: 'navigationStart',
  FETCH_START: 'fetchStart',
  DOMAIN_LOOKUP_START: 'domainLookupStart',
  DOMAIN_LOOKUP_END: 'domainLookupEnd',
  CONNECT_START: 'connectStart',
  CONNECT_END: 'connectEnd',
  REQUEST_START: 'requestStart',
  RESPONSE_START: 'responseStart',
  RESPONSE_END: 'responseEnd',
  DOM_LOADING: 'domLoading'
};
var endMetrics = {
  // DOM changes died down; treat interactivity/loaded/complete as the same thing
  DOM_INTERACTIVE: 'domInteractive',
  DOM_CONTENT_LOADED: 'domContentLoaded',
  DOM_COMPLETE: 'domComplete',
  // Since there is no actual onLoad event, use the final timestamp to simulate an empty onLoad event invocation
  LOAD_EVENT_START: 'loadEventStart',
  LOAD_EVENT_END: 'loadEventEnd'
};
var metrics = _objectSpread(_objectSpread({}, startMetrics), endMetrics);
var START_METRIC = 'start';
var END_METRIC = 'end';
var LAUNCH_EVENT = 'launch';
var BUNDLE_REQUEST_EVENT = 'bundle-request';
function createPerfTracker(namespace) {
  var MARK_PREFIX = [LOADER_NAMESPACE, namespace].join('-');

  /**
   * Checks to see if a particular event has been fired before.  If it hasn't it saves a token in
   * the session storage to mark that it has been called once.
   * @param {string} eventName Event name
   * @returns {boolean} Has this event been fired
   */
  function isFirstEventCall(eventName) {
    if (typeof sessionStorage !== 'undefined') {
      var eventRecords = {};
      try {
        eventRecords = JSON.parse(sessionStorage.getItem(MARK_PREFIX)) || {};
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Invalid metric session storage', e);
      }
      var isCalledBefore = eventRecords[eventName];
      if (!isCalledBefore) {
        eventRecords[eventName] = true;
        sessionStorage.setItem(MARK_PREFIX, JSON.stringify(eventRecords));
      }
      return !isCalledBefore;
    }
    return false;
  }
  function invokePerfApi(perfFunc) {
    if (typeof window !== 'undefined' && window.performance && window.performance[perfFunc]) {
      var _window$performance;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return (_window$performance = window.performance)[perfFunc].apply(_window$performance, args);
    }
  }
  function getMarkName(eventName, metric) {
    return [MARK_PREFIX, eventName, metric].join('-');
  }
  function getMark(markName) {
    var marks = invokePerfApi('getEntriesByName', markName);
    if (!marks || marks.length < 1) return;
    return marks[0];
  }
  function getAllMetricMarks(eventName) {
    var marks = {};
    Object.values(metrics).forEach(function (metric) {
      marks[metric] = getMark(getMarkName(eventName, metric));
    });
    return marks;
  }
  function clearMarks(eventName) {
    if (!eventName) return;
    Object.values(metrics).forEach(function (metric) {
      return invokePerfApi('clearMarks', getMarkName(eventName, metric));
    });
    invokePerfApi('clearMarks', getMarkName(eventName, START_METRIC));
    invokePerfApi('clearMarks', getMarkName(eventName, END_METRIC));
  }
  function logVirtualPagePerf(data) {
    var logData = {
      schema: 'add_virtual_page_perf',
      version: 'v1',
      data: data
    };
    (window._expDataLayer || (window._expDataLayer = [])).push(logData);
  }
  function getLogParams(eventName, start, end) {
    // HACK We use a Go Daddy framework called Traffic2 to record performance data.  This framework
    // appears to to be set up to record performance measures from page loads.  Since we want to
    // record the performance of other things, we end up having to encode our performance measures
    // in page load metrics.  This results in the things we want to measure showing up as "page
    // load time" (plt) for dummy pages.
    // TODO see if there is a better way to record our performance measures for Traffic2
    var metricMarks = getAllMetricMarks(eventName);
    function getMetricValue(name, fallback) {
      return metricMarks[name] && metricMarks[name].startTime || fallback;
    }
    var startLogParams = {};
    Object.values(startMetrics).forEach(function (metric) {
      startLogParams[metric] = getMetricValue(metric, start);
    });
    var endLogParams = {};
    Object.values(endMetrics).forEach(function (metric) {
      endLogParams[metric] = getMetricValue(metric, end);
    });
    return {
      virtual_path: "/beacon/".concat(LOADER_NAMESPACE, "/").concat(namespace, "/").concat(eventName),
      timing_metrics: _objectSpread(_objectSpread({}, startLogParams), endLogParams),
      custom_properties: {
        firstSessionCall: isFirstEventCall(eventName)
      }
    };
  }
  function createMark(eventName, metric) {
    var name = getMarkName(eventName, metric);
    if (!getMark(name)) {
      invokePerfApi('mark', name);
    }
  }
  function startEvent(eventName) {
    createMark(eventName, START_METRIC);
  }
  function endEvent(eventName) {
    if (!eventName) return;
    var startMark = getMark(getMarkName(eventName, START_METRIC));
    if (!startMark) return;
    var endMarkName = getMarkName(eventName, END_METRIC);
    invokePerfApi('mark', endMarkName);
    var endMark = invokePerfApi('getEntriesByName', endMarkName)[0];
    logVirtualPagePerf(getLogParams(eventName, startMark.startTime, endMark.startTime));
    clearMarks(eventName);
  }
  return {
    markLaunchStart: function markLaunchStart() {
      startEvent(LAUNCH_EVENT);
    },
    markLaunchEnd: function markLaunchEnd() {
      endEvent(LAUNCH_EVENT);
    },
    markBundleRequestStart: function markBundleRequestStart() {
      startEvent(BUNDLE_REQUEST_EVENT);
    },
    markBundleRequestEnd: function markBundleRequestEnd() {
      endEvent(BUNDLE_REQUEST_EVENT);
    },
    startEvent: startEvent,
    endEvent: endEvent
  };
}